import { declareVueComponent } from '/vodalys/vvuejs'

import FQuestionAsk from './components/FQuestionAsk.vue'

declareVueComponent('FQuestionAsk', FQuestionAsk)
